var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMounted)?_c('div',{staticClass:"slider swiper-container",attrs:{"id":_vm.name}},[_vm._t("pagination"),_vm._v(" "),_c('div',{staticClass:"swiper-wrapper"},[_vm._t("slide")],2)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }